import CodingEntityDropdown from 'app/pages/overview/tabs/transactions/CodingEntityDropdown';
import { AgaveProject, HighnoteTransactionEvent } from 'API';

interface AgaveProjectsDropdownProps {
  disabled?: boolean;
  disableHeader?: boolean;
  selectedProject?: AgaveProject | null;
  onValueChange: (option: AgaveProject | null) => void;
  transaction?: HighnoteTransactionEvent;
  placeholder?: string | null;
  enabled?: boolean;
  /** SEE-944 — when set, projects are narrowed to those mapped to this
   * location. Caller is responsible for gating this on the paidol toggle
   * filterProjectsByEmployeeLocationEnabled and passing the transaction's
   * currently selected location id (auto-filled from employee or picked
   * manually). */
  locationId?: string;
}

const AgaveProjectsDropdown = ({
  disabled,
  disableHeader = true,
  selectedProject,
  onValueChange,
  transaction,
  placeholder,
  enabled = true,
  locationId,
}: AgaveProjectsDropdownProps) => {
  return (
    <CodingEntityDropdown<AgaveProject>
      entityType="projects"
      selectedItem={selectedProject}
      onValueChange={onValueChange}
      disabled={disabled}
      disableHeader={disableHeader}
      placeholder={placeholder || undefined}
      identifierField="number"
      cardGroupId={transaction?.cardGroupId || undefined}
      locationId={locationId}
      enabled={enabled}
    />
  );
};

export default AgaveProjectsDropdown;
